import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HuntContextService } from '../../../../../services/hunt-context.service'
import { TypographyComponent, BadgeComponent, MarkdownComponent, LinkComponent } from '@hyperkit';
import { CollectionService } from 'apps/hunter/portal/frontend/src/app/modules/research/services/collection.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { SearchUrlService } from 'apps/hunter/portal/frontend/src/app/modules/research/services/search-url.service';
import { ThreatProfileService } from 'apps/hunter/portal/frontend/src/app/modules/shared/services/threat-profile.service';
import { RouterModule } from '@angular/router';


@Component({
  standalone: true,
  selector: 'default-overview-tab',
  imports: [CommonModule, TypographyComponent, BadgeComponent, MarkdownComponent, LinkComponent, RouterModule],
  templateUrl: './overview-tab.component.html',
  styleUrl: './overview-tab.component.scss',
})
export class OverviewTabComponent {
  readonly hunt = inject(HuntContextService);
  readonly collectionService = inject(CollectionService);
  readonly searchUrlService = inject(SearchUrlService);
  readonly threatProfileService = inject(ThreatProfileService);

  readonly relatedCollections = toSignal(
    this.collectionService
      .getRelatedCollectionsByHuntPackageUUID(this.hunt.editor.activePackage().UUID)
      .pipe(
        catchError(err => {
          console.error('Failed to load related collections', err);
          return of([]); // ✅ fallback to empty array
        })
      ),
    { initialValue: [] }
  );
  
  readonly relatedThreatProfiles = toSignal(
    this.threatProfileService
      .getThreatProfilebyThreatName(this.hunt.editor.activePackage())
      .pipe(
        catchError(err => {
          console.error('Failed to load related threat profiles', err);
          return of([]); // ✅ fallback to empty array
        })
      ),
    { initialValue: [] }
  );
  
navigateToCollection(collectionId: string): void {   
  console.log('Navigating to collection:', collectionId);
  this.searchUrlService.navigateToCollection(collectionId);
  // Implement your navigation logic here
  }
}
